import React from "react";

interface NoPosterProps {
  variant?: "movie" | "person";
}

export const NoPoster: React.FC<NoPosterProps> = ({variant = "movie"}) => (
  <div
    className="w-full h-full flex items-center justify-center"
    style={{background: "linear-gradient(160deg, var(--raised-2) 0%, var(--raised) 100%)"}}
  >
    {variant === "person" ? (
      <svg
        width="38%" height="38%"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1"
        strokeLinecap="round" strokeLinejoin="round"
        className="text-t3 opacity-30"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    ) : (
      <svg
        width="38%" height="38%"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1"
        strokeLinecap="round" strokeLinejoin="round"
        className="text-t3 opacity-30"
      >
        {/* Film frame */}
        <rect x="2" y="2" width="20" height="20" rx="2"/>
        <line x1="7" y1="2" x2="7" y2="22"/>
        <line x1="17" y1="2" x2="17" y2="22"/>
        <line x1="2" y1="12" x2="22" y2="12"/>
        <line x1="2" y1="7" x2="7" y2="7"/>
        <line x1="2" y1="17" x2="7" y2="17"/>
        <line x1="17" y1="7" x2="22" y2="7"/>
        <line x1="17" y1="17" x2="22" y2="17"/>
      </svg>
    )}
  </div>
);
